import { useNavigate } from 'react-router';
import {
  ResourceCard,
  ResourceCardContainer,
  ResourceCardContent,
  ResourceCardHeader,
  ResourceCardMetaItem,
  ResourceCardTitle,
} from '@/components/shared/resource-card';
import type { Video } from '@/data/resource-catalog/interfaces';
import { formatVideoDurationWithChannel } from '@/utils/format-video-duration';

export const VideoCard = ({ video }: { video: Video }) => {
  const navigate = useNavigate();
  const path = `/videos/${video.uuid}`;

  const handleVideoClick = () => {
    navigate(path);
  };

  return (
    <ResourceCard onClick={handleVideoClick} href={path}>
      <ResourceCardHeader
        image={{ src: video.thumbnail_url, alt: "", type: 'video' }}
      />
      <ResourceCardContainer>
        <ResourceCardTitle>{video.revisioned_title}</ResourceCardTitle>
        <ResourceCardContent>
          <ResourceCardMetaItem icon="PlayCircleOutline">
            Vídeo
          </ResourceCardMetaItem>
          <ResourceCardMetaItem icon="AccessTime">
            {formatVideoDurationWithChannel(
              video.duration_in_seconds,
              video.channel_title
            )}
          </ResourceCardMetaItem>
        </ResourceCardContent>
      </ResourceCardContainer>
    </ResourceCard>
  );
};
